export default "__VITE_ASSET__BArc1Yl0__"